import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { LegendItemList, type LegendItem } from "@/components/MapLegend";
import { BLOCKAGE_STATUS_COLORS, BLOCKAGE_STATUS_LABELS } from "@/config/blockageStatus";
import type { IBlockageStatusValues } from "@/types/dryp/Blockage";

interface BlockagesLegendProps {
	blockages: Dryp.Blockage[];
}

export const BlockagesLegend = observer(({ blockages }: BlockagesLegendProps) => {
	const items = useMemo(() => {
		const counts = new Map<string, LegendItem>();
		for (const blockageItem of blockages) {
			const status: IBlockageStatusValues = blockageItem.status?.status ?? "NoData";
			const existing = counts.get(status);
			if (existing) {
				existing.count++;
			} else {
				counts.set(status, {
					label: BLOCKAGE_STATUS_LABELS[status],
					color: BLOCKAGE_STATUS_COLORS[status],
					count: 1,
				});
			}
		}
		return [...counts.values()].sort((firstItem, secondItem) => secondItem.count - firstItem.count);
	}, [blockages]);

	return <LegendItemList items={items} />;
});
